import { PROJECTS_SORT_OPTIONS, PROJECTS_SORT_API_ENUMS } from 'sh-www/constants/routes/projects';
import { APPLICATION_SIMPLE_STATUS } from 'sh-www/models/application';

import { sellerProjectsViewControllerFactory } from './seller';

const sortOptions = Object.freeze({
  [PROJECTS_SORT_OPTIONS.LAST_ACTIVITY]: PROJECTS_SORT_API_ENUMS.LAST_ACTIVITY,
  [PROJECTS_SORT_OPTIONS.UNREAD_MESSAGES]: PROJECTS_SORT_API_ENUMS.UNREAD_MESSAGES,
});

export default sellerProjectsViewControllerFactory({
  sortOptions,
  defaultFilter: APPLICATION_SIMPLE_STATUS.IN_PROGRESS,
  emptyText: "You don't have any projects in progress",
});
